module.exports = __webpack_public_path__ + "static/media/loginImage.c2c225df.png";